import gPhoneNumber from 'google-libphonenumber';

export const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance();

export const formatPhoneNumber = (phoneNumber, fallback = 'Not Set') => {
  if (!phoneNumber) {
    return fallback;
  }
  try {
    const parsedPhoneNumber = phoneUtil.parse(phoneNumber, 'CA');
    return phoneUtil.format(parsedPhoneNumber, gPhoneNumber.PhoneNumberFormat.NATIONAL);
  } catch {
    return fallback;
  }
};

export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return false;
  }

  try {
    const parsedPhoneNumber = phoneUtil.parse(phoneNumber, 'CA');

    if (
      !parsedPhoneNumber ||
      !phoneUtil.isPossibleNumber(parsedPhoneNumber) ||
      !phoneUtil.isValidNumber(parsedPhoneNumber)
    ) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};
